<now-wbsuche-lib-basis-facette
  [id]="'ort'"
  [label]="'Ort'"
  [facettenService]="facettenService"
  [isLoading]="(this.loaderService.facettenLoadingFirstTime$ | async)!"
>
  @if (expanded()) {
    <div id="ortFacette">
      <now-wbsuche-lib-ort-suche-suchzeile
        class="ortsuche"
        [postleitzahl]="postleitzahl"
      ></now-wbsuche-lib-ort-suche-suchzeile>
      @if (showOrtsunabhaengig) {
        <now-wbsuche-lib-ort-suche-ortsunabhaengig
          class="mt-2"
        ></now-wbsuche-lib-ort-suche-ortsunabhaengig>
      }
    </div>
  }
</now-wbsuche-lib-basis-facette>
